import styled from "@emotion/styled";
import { Card } from "./card.type";
import { HeadingWithStep } from "../heading-with-step";
import { ArrowLink } from "../../blog/arrow-link";
import { breakpoints } from "../../../styles/breakpoints";

const StyledHorizontalCard = styled.div`
  display: flex;
  align-items: center;
  background-color: var(--white);
  padding: var(--xx-small);
  text-align: left;
  gap: var(--xx-small);

  @media(max-width: ${breakpoints.sm}) {
    flex-direction: column;
    max-width: 400px;
  }

  .h3 {
    margin-bottom: var(--macro);
  }

  p.with-link {
    margin-bottom: var(--macro);
  }

  .img-container {
    height: 200px;
    flex: 0 0 250px;

    @media(max-width: ${breakpoints.md}) {
      flex: 0 0 200px;
      height: 150px;
    }

    @media(max-width: ${breakpoints.sm}) {
    }
  }

  .img-container-wide {
    height: 300px;
    flex: 0 0 300px;
  }
`;

export const HorizontalCard = ({
  title,
  text,
  image,
  step,
  children,
  link,
}: Card) => (
  <StyledHorizontalCard>
    {image ? <img src={image.src} alt={image.alt} /> : null}
    {children}
    <div className="text">
      {step ? (
        <HeadingWithStep
          type="h3"
          step={{ src: step.src, alt: `${step.number}` }}
        >
          {title}
        </HeadingWithStep>
      ) : (
        <h3 className="h3">{title}</h3>
      )}
      <p className={link ? "with-link" : ""}>{text}</p>
      {link ? (
        <ArrowLink 
          url={link.url}
          text={link.text}
        />
      ) : null}
    </div>
  </StyledHorizontalCard>
);
